import { useEffect, useState, useRef } from 'react';
import { useQuery } from "@tanstack/react-query";
import useUserToken from '../../context/userTokenContext';
import { getDevicesCounters, getDevices, getAvailableLocations } from '../../api/apiCalls';
// import DevicesDataTable from '../dataTables/devicesDataTable';
import DevicesDataTableWithLocalization from '../dataTables/devicesDataTable';
import Stats from '../stats';
import DevicesMap from '../mapComponents/devicesMap';
import useLocationsStore from '../../context/locationsStore';
import { LoadingSpinner } from '../spinners';

import { IoFilterSharp } from "react-icons/io5";
import { BiFilterAlt } from "react-icons/bi";

function DevicesPage() {
    const [success, setSuccess] = useState(false);
    const [deviceList, setDeviceList] = useState([]);

    const [devicesCounters, setDevicesCounters] = useState([]);
    const [devicesSuccess, setDevicesSuccess] = useState(false);

    const [availableLocations, setAvailableLocations] = useState([]);
    const [locationsSuccess, setLocationsSuccess] = useState(false);

    const [domainCounters, setDomainCounters] = useState([]);
    const [domainCountersSuccess, setDomainCountersSuccess] = useState(false);

    const [filteredLocation, setFilteredLocation] = useState(null);

    const [selectedTag, setSelectedTag] = useState(null);

    // const [availableTags, setAvailableTags] = useState(['TOEB Sidirokastrou', 'Sirri3_Installed']);
    const [availableTags, setAvailableTags] = useState([]);

    const [newCenter, setNewCenter] = useState([]);

    const [targetMarker, setTargetMarker] = useState(null);

    const mapRef = useRef(null);

    const handleZoomToLocation = (coordinates, zoomLevel) => {
        if (mapRef.current) {
            mapRef.current.zoomToCoordinates(coordinates, zoomLevel);
        }
    };

    const { locations } = useLocationsStore();
    // const locations = null

    // const { setSearchList } = useNavbarSearchStore();

    const statusObject = {
        0: 'fail',
        1: 'active',
        2: 'init',
        3: 'error'
    };

    // Query for devices with conditional enabled based on filteredLocation
    const { data: devicesData, isLoading: devicesIsLoading, isError: devicesIsError, error: devicesError } = useQuery({
        queryKey: ['getDevices', filteredLocation], // Include filteredLocation in the query key to refetch when it changes
        queryFn: () => getDevices(filteredLocation), // Pass filteredLocation to getDevices
        enabled: filteredLocation !== null, // Only run the query if filteredLocation is not null
    });

    const { data: availableLocationsData, isLoading: availableLocationsIsLoading, isError: availableLocationsIsError, error: availableLocationsError } = useQuery({
        queryKey: ['getAvailableLocations'],
        queryFn: getAvailableLocations
    });

    const { data: devicesCountersData, isLoading: devicesCountersDataIsLoading, isError: devicesCountersDataIsError, error: devicesCountersDataError } = useQuery({
        queryKey: ['getDevicesCounters'],
        queryFn: getDevicesCounters
    });

    useEffect(() => {
        if (devicesData && devicesData.data) {
            let listArr = [];
            let totalCounters = { total: 0, active: 0, fail: 0, init: 0, error: 0 };

            if (selectedTag !== null) { // If no tag is selected, calculate all devices

                Object.entries(devicesData.data.devices).forEach(([key, device]) => {

                    if (device.tags && device.tags.includes(selectedTag)) {
                        listArr.push({
                            name: device.name,
                            deveui: device.deveui,
                            status: statusObject[device.status],
                            rssiavg: device.rssiavg,
                            snravg: device.snravg,
                            lastuptimestamp: device.lastuptimestamp,
                            locations: device.location
                                ? (locations && locations[device.location] ? locations[device.location].name : device.location)
                                : 'notAssigned',
                            server: device.server,
                            latitude: device.latitude,
                            longitude: device.longitude,
                            espavg: device.avgESP,
                            batlevel: device.batLevel,
                            bestlrr: device.bestLRR,
                            tags: device.tags
                        });

                        if (device.location !== 'global') {
                            totalCounters.total++;
                            switch (device.status) {
                                case 0:
                                    totalCounters.fail++;
                                    break;
                                case 1:
                                    totalCounters.active++;
                                    break;
                                case 2:
                                    totalCounters.init++;
                                    break;
                                case 3:
                                    totalCounters.error++;
                                    break;
                                default:
                                    break;
                            }
                        }
                    }

                    setDomainCounters([totalCounters]);
                    setDomainCountersSuccess(true);

                    setDeviceList(listArr);
                    setSuccess(true);

                });


            } else { // If no tag is selected, calculate all devices

                let tagsAvailable = [];

                Object.entries(devicesData.data.devices).forEach(([key, device]) => {
                    listArr.push({
                        name: device.name,
                        deveui: device.deveui,
                        status: statusObject[device.status],
                        rssiavg: device.rssiavg,
                        snravg: device.snravg,
                        lastuptimestamp: device.lastuptimestamp,
                        locations: device.location
                            ? (locations && locations[device.location] ? locations[device.location].name : device.location)
                            : 'notAssigned',
                        server: device.server,
                        latitude: device.latitude,
                        longitude: device.longitude,
                        espavg: device.avgESP,
                        batlevel: device.batLevel,
                        bestlrr: device.bestLRR,
                        tags: device.tags
                    });

                    if (device.tags) {
                        device.tags.forEach(tag => {
                            if (!tagsAvailable.includes(tag)) {
                                tagsAvailable.push(tag);
                            }
                        });
                    }

                    if (device.location !== 'global') {
                        totalCounters.total++;
                        switch (device.status) {
                            case 0:
                                totalCounters.fail++;
                                break;
                            case 1:
                                totalCounters.active++;
                                break;
                            case 2:
                                totalCounters.init++;
                                break;
                            case 3:
                                totalCounters.error++;
                                break;
                            default:
                                break;
                        }
                    }
                });

                console.log('tagsAvailable', tagsAvailable);
                setAvailableTags(tagsAvailable);

                setDomainCounters([totalCounters]);
                setDomainCountersSuccess(true);

                setDeviceList(listArr);
                setSuccess(true);

            }

            // setDomainCounters([totalCounters]);
            // setDomainCountersSuccess(true);

            // setDeviceList(listArr);
            // setSuccess(true);
        }
    }, [devicesData, selectedTag]);

    useEffect(() => {
        if (devicesCountersData && devicesCountersData.data) {
            let totalCounters = { total: 0, active: 0, fail: 0, init: 0, error: 0 };
            Object.entries(devicesCountersData.data.groups).forEach(([domainName, domainData]) => {
                if (domainName !== 'global') {
                    totalCounters.total += domainData.total;
                    totalCounters.active += domainData.active;
                    totalCounters.fail += domainData.fail;
                    totalCounters.init += domainData.init;
                    totalCounters.error += domainData.error;
                }
            });
            setDevicesCounters([totalCounters]);
            setDevicesSuccess(true);
        }
    }, [devicesCountersData]);

    useEffect(() => {
        if (availableLocationsData && availableLocationsData.data && availableLocationsData.data.locations) {
            console.log(availableLocationsData.data.locations);
            setAvailableLocations(availableLocationsData.data.locations);
            setLocationsSuccess(true);
        }
    }, [availableLocationsData]);

    useEffect(() => {
        console.log('filteredLocation', filteredLocation);
    }, [filteredLocation]);

    useEffect(() => {
        if (targetMarker) {
            console.log('targetMarker', targetMarker);
            handleZoomToLocation([targetMarker.latitude, targetMarker.longitude], 18);
        }
    }, [targetMarker]);

    // Handle location click
    const handleLocationClick = (location) => {

        if (location === filteredLocation) {
            return;
        }

        setSelectedTag(null);

        setDomainCountersSuccess(false);
        setSuccess(false);

        setNewCenter(locations[location] ? [locations[location].latitude, locations[location].longitude] : [38.27, 23.81]);
        setFilteredLocation(location);
    };

    // Handle tag click
    const handleTagClick = (tag) => {

        if (tag === selectedTag) {
            return;
        }

        setDomainCountersSuccess(false);
        setSuccess(false);

        setSelectedTag(tag);
    };

    // Handle tag click
    const handleTagClear = () => {

        if (selectedTag === null) {
            return;
        }

        setSelectedTag(null);
    };

    return (
        <div>
            {devicesCountersDataIsError && <p>Error loading counters: {devicesCountersDataError.message}</p>}
            {devicesIsError && <p>Error loading devices: {devicesError.message}</p>}

            <div className='mt-10'>
                {devicesSuccess ?
                    <div className='flex flex-row justify-start items-start'>
                        <p className='flex justify-start text-2xl font-bold'>Total Client's Devices</p>
                        <span className="badge badge-outline ml-4 text-[var(--textPrimary)] font-bold text-nowrap">{new Date(devicesCountersData.data.lastUpdate).toLocaleString('en-GB')}</span>
                    </div>
                    :
                    <div>
                        <p className='flex justify-start text-2xl font-bold'>Total Client's Devices</p>
                        <span className="animate-pulse bg-[var(--skeleton-bg)] rounded-full h-4 w-36"></span>
                    </div>
                }
            </div>


            <div tabIndex={0} className="collapse collapse-plus bg-[var(--gradientPrimary)] mt-6">
                <input type="checkbox" defaultChecked />
                <div className="collapse-title text-xl font-medium">
                    <div className='flex flex-row justify-start items-center gap-4'>
                        <span><IoFilterSharp /></span>
                        <h1>Location Filters</h1>
                    </div>
                </div>
                <div className="collapse-content">
                    {locationsSuccess ?
                        <ul className="menu grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 p-4 shadow-lg bg-[var(--gradientPrimary)] rounded-box w-full">
                            {locationsSuccess && availableLocations.length > 0 ? (
                                availableLocations.map((location, index) => (
                                    <li key={index} className='items-center'>
                                        <a onClick={() => handleLocationClick(location)}>{location
                                            ? (locations && locations[location] ? locations[location].name : location)
                                            : 'notAssigned'}</a>
                                    </li>
                                ))
                            ) : (
                                <div>No locations available</div>
                            )}
                        </ul>
                        :
                        <div className='flex flex-row justify-center items-center gap-4'>
                            <span><LoadingSpinner size="lg" /></span>
                            <h1>Loading Locations...</h1>
                        </div>
                    }

                </div>
            </div>

            {!filteredLocation && <h1>Please Select Location from Filters</h1>}

            <div tabIndex={0} className="collapse collapse-plus bg-[var(--gradientPrimary)] mt-6">
                <input type="checkbox" />
                <div className="collapse-title text-xl font-medium">
                    <div className='flex flex-row justify-start items-center gap-4'>
                        <span><IoFilterSharp /></span>
                        <h1>Tag Filters</h1>
                    </div>
                </div>
                <div className="collapse-content">
                    <ul className="menu grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 p-4 shadow-lg bg-[var(--gradientPrimary)] rounded-box w-full">
                        {availableTags.length > 0 ? (
                            availableTags.map((tag, index) => (
                                <li key={index} className='items-center'>
                                    <a onClick={() => handleTagClick(tag)}>{tag}</a>
                                </li>
                            ))
                        ) : (
                            <div>No Tags available</div>
                        )}
                    </ul>
                </div>
            </div>

            {
                filteredLocation && !success &&
                <div className='flex justify-center items-center mt-10'>
                    <LoadingSpinner size="lg" />
                </div>
            }

            {
                domainCountersSuccess && domainCounters && filteredLocation && <p className='flex justify-start mt-10 text-2xl font-bold'>{filteredLocation
                    ? (filteredLocation && locations[filteredLocation] ? locations[filteredLocation].name : filteredLocation)
                    : ''}</p>
            }

            {selectedTag &&
                <div className='flex flex-row justify-start items-center gap-4 mt-2'>
                    <p className='text-sm flex flex-row justify-start items-center font-bold gap-2'>
                        <span><BiFilterAlt /></span>
                        {selectedTag}
                    </p>
                    {selectedTag && <button onClick={handleTagClear} className='flex justify-start rounded-md px-2 text-start btn btn-sm btn-outline btn-error'>Clear Tag Filter</button>}
                </div>
            }

            {
                domainCountersSuccess && domainCounters &&
                <Stats counters={domainCounters} type="devices" />
            }

            {
                success && !devicesIsError &&
                <div className='w-full bg-[var(--primary)] rounded-2xl mt-6'>
                    <DevicesMap center={newCenter} zoom={6} markers={deviceList} ref={mapRef} />
                </div>
            }

            {
                success && !devicesIsError &&
                <div className='w-full bg-[var(--primary)] rounded-2xl mt-6 mb-20'>
                    <DevicesDataTableWithLocalization
                        data={deviceList}
                        location={filteredLocation
                            ? (filteredLocation && locations[filteredLocation] ? locations[filteredLocation].name : filteredLocation)
                            : ''}
                        setTargetMarker={setTargetMarker} />
                </div>
            }
        </div >
    );
}

export default DevicesPage;